import { AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { IReduxRootState } from '../../../app/reduxRootState.interface';
import {
    ErrorResolution,
    ErrorResolutionTypes,
} from '../../../app/common/errorResolution/errorResolution';
import { RevokeSessionActionTypes } from './revokeSessionActionTypes';
import { ErrorResolutionActions } from '../../../app/common/errorResolution/errorResolutionActions';
import { NotificationsActions } from '../../../app/common/notifications/notificationsActions';
import ErrorRedirectService from '../../../routes/error/errorRedirect.service';
import { NOTIFICATIONS } from '../../../app/common/constants/styles';
import { NotificationType } from '../../../app/common/notifications/notificationType.enum';
import { RevokeSessionService } from './revokeSession.services';
import { addRatEvent } from '../../../utils/ratClickEvents';

export class RevokeSessionActions {
    public static revokeUserSessions(): ThunkAction<void, IReduxRootState, {}, AnyAction> {
        addRatEvent('session_deactivation', 'revoke_user_sessions');
        return async (
            dispatch: ThunkDispatch<IReduxRootState, {}, AnyAction>,
            getState: () => IReduxRootState,
        ) => {
            try {
                dispatch(request());
                // revoke all the active sessions for user
                const sessionRevokeRespone = await RevokeSessionService.requestSessionRevoke();
                if (!!sessionRevokeRespone) {
                    const tokenExpirationUrl = getState().app.clientConfig.tokenExpirationUrl;
                    success(dispatch, tokenExpirationUrl);
                }
            } catch (error) {
                const errorResolution = error as ErrorResolution;
                return failure(dispatch, errorResolution);
            }
        };

        function request() {
            return { type: RevokeSessionActionTypes.SEND_SESSION_REVOKE_REQUEST };
        }

        function success(
            dispatch: ThunkDispatch<IReduxRootState, {}, AnyAction>,
            tokenExpirationUrl: string,
        ) {
            addRatEvent('session_deactivation', 'revoke_user_sessions_success');
            dispatch({
                type: RevokeSessionActionTypes.SEND_SESSION_REVOKE_SUCCESS,
            });
            dispatch(
                NotificationsActions.showRedirectSuccess('notification.revoke.session.success'),
            );
            // redirect the user to login page after session revocation
            setInterval(() => {
                ErrorRedirectService.takeToLogout(tokenExpirationUrl.toString());
            }, NOTIFICATIONS[NotificationType.Success_Redirecting].expiry);
        }

        function failure(
            dispatch: ThunkDispatch<IReduxRootState, {}, AnyAction>,
            errorResolution: ErrorResolution,
        ) {
            dispatch({
                type: RevokeSessionActionTypes.SEND_SESSION_REVOKE_FAILURE,
                payload: { errorResolution: errorResolution },
            });
            dispatch(
                ErrorResolutionActions.processErrorResolution({
                    errorMessageId: 'notifications.something_went_wrong',
                    type: ErrorResolutionTypes.ERROR_CODE_MESSAGE,
                }),
            );
        }
    }

    public static setSessionRevoke(signOutFromAllDevices: boolean) {
        return {
            type: RevokeSessionActionTypes.SET_SESSION_REVOKE,
            payload: signOutFromAllDevices,
        };
    }
}
